/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MonobankPaymentPageDto } from '../../models/monobank-payment-page-dto';

export interface GetMonobankPayment$Params {
  id: number;
}

export function getMonobankPayment(http: HttpClient, rootUrl: string, params: GetMonobankPayment$Params, context?: HttpContext): Observable<StrictHttpResponse<MonobankPaymentPageDto>> {
  const rb = new RequestBuilder(rootUrl, getMonobankPayment.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MonobankPaymentPageDto>;
    })
  );
}

getMonobankPayment.PATH = '/api/v1/order/{id}/monobank-payment';
